const ESTADOS = new Set(['PRESENTE', 'TARDANZA', 'AUSENTE']);

export function estadoConfirmado(valor) {
  return ESTADOS.has(valor) ? valor : null;
}

// La respuesta de escritura identifica cada estudiante/horario. Un 2xx o los
// contadores globales no acreditan una marca particular.
export function interpretarMarcado(respuesta, contexto) {
  const { estudianteID, horariosIDs, colegioID, fecha, anioEscolar } = contexto;
  const confirmadas = [];
  const fallidas = [];
  const fallo = (horarioID, mensaje) => fallidas.push({ horarioID, mensaje });
  if (!respuesta || respuesta.success === false || respuesta.error || respuesta.status_code === 202 ||
      respuesta.reintentable === true || respuesta.recepcionDuradera === true ||
      respuesta.estado === 'recibido_pendiente' || respuesta.data?.estado === 'recibido_pendiente') {
    const mensaje = respuesta?.error?.message || 'El registro sigue pendiente. Puedes volver a comprobarlo.';
    horariosIDs.forEach(id => fallo(id, mensaje));
    return { confirmadas, fallidas };
  }
  if (Array.isArray(respuesta.resultado?.clases)) {
    for (const horarioID of horariosIDs) {
      const entradas = respuesta.resultado.clases.filter(clase => clase.horarioID === horarioID);
      if (entradas.length !== 1) {
        fallo(horarioID, 'No se recibió una confirmación única de esta materia.');
        continue;
      }
      const clase = entradas[0];
      const exitosas = clase.resultados?.exitosas;
      const errores = clase.resultados?.fallidas;
      const errorPropio = Array.isArray(errores) && errores.find(error => error.estudianteID === estudianteID);
      if (!clase.error && Array.isArray(exitosas) && Array.isArray(errores) &&
          exitosas.length === 1 && exitosas[0] === estudianteID && errores.length === 0 &&
          clase.exitosas === exitosas.length && clase.fallidas === errores.length) {
        // El lote confirma la escritura, pero no devuelve el Estado final
        // (el servidor puede convertir PRESENTE a TARDANZA). Releerlo.
        confirmadas.push({ horarioID, estado: null });
      } else {
        fallo(horarioID, errorPropio?.error || clase.error || 'No se pudo registrar esta materia.');
      }
    }
    return { confirmadas, fallidas };
  }
  const marca = respuesta.asistencia;
  if (horariosIDs.length === 1 && marca && marca.EstudianteID === estudianteID &&
      marca.HorarioID === horariosIDs[0] && marca.ColegioID === colegioID && marca.Fecha === fecha &&
      String(marca.AnioEscolar) === String(anioEscolar) && estadoConfirmado(marca.Estado)) {
    confirmadas.push({ horarioID: horariosIDs[0], estado: marca.Estado });
  } else {
    horariosIDs.forEach(id => fallo(id, 'No se pudo confirmar la marca de este estudiante.'));
  }
  return { confirmadas, fallidas };
}
